var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Spinner", { attrs: { id: "spinner", "is-loading": _vm.isLoading } }),
      !_vm.isLoading
        ? _c("div", { staticClass: "card-item" }, [
            _c(
              "div",
              [
                _c(
                  "b-field",
                  { staticClass: "m-5" },
                  [
                    _c("FindEntitiesInput", {
                      staticClass: "search-clients",
                      attrs: {
                        id: "find-clients-input",
                        placeholder: _vm.$t("search"),
                        expanded: true,
                        finder: _vm.finder,
                      },
                      on: {
                        select: function ($event) {
                          return _vm.clickedOnClient($event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.client
              ? _c("div", [
                  _vm.errorGettingClientOperations.fail
                    ? _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errorGettingClientOperations.message) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.clientOperations.length > 0
                    ? _c("div", [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("operationsLabel")) +
                              " " +
                              _vm._s(_vm.client.name)
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "operations-list" },
                          _vm._l(_vm.clientOperations, function (operation) {
                            return _c(
                              "div",
                              { key: operation._id, staticClass: "card-item" },
                              [
                                _c("div", { staticClass: "operation-header" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("operationLabel")) +
                                        " " +
                                        _vm._s(operation.companyOperationId)
                                    ),
                                  ]),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        id: `extend-${operation.companyOperationId}`,
                                        href: "#",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setSelectedOperation(
                                            operation.companyOperationId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa",
                                        class:
                                          operation.companyOperationId ===
                                          _vm.selectedOperation
                                            ? "fa-minus-circle"
                                            : "fa-plus-circle",
                                      }),
                                    ]
                                  ),
                                ]),
                                operation.companyOperationId ===
                                _vm.selectedOperation
                                  ? _c("OperationModifier", {
                                      attrs: { operation: operation },
                                      on: {
                                        "cap-modification": _vm.refreshClient,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }